import styled from '@emotion/styled';
import Badge from '@mui/material/Badge';

const StyledBadge = styled<any>(Badge)`
  .MuiBadge-badge {
    background-color: ${({ color }) => color};
  }
`;

type IconBadgeProps = {
  children?: React.ReactNode;
  badgeContent?: React.ReactNode;
  color?: string;
};

export default function IconBadge({
  children,
  badgeContent,
  color,
  ...props
}: Readonly<IconBadgeProps>) {
  return (
    <StyledBadge badgeContent={badgeContent} color={color} {...props}>
      {children}
    </StyledBadge>
  );
}
